<template>
    <div class="dispositivos-container">
        <div class="dispositivos-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DispositivosLayout',
    data() {
        return {
            userName: window.sessionStorage.getItem('nombre') || 'Usuario DM'
        }
    },
    methods: {
        logout() {
            window.sessionStorage.clear();
            this.$router.push('/');
        }
    }
}
</script>

<style lang="scss" scoped>
.dispositivos-container {
    display: flex;
    height: 100vh;
    width: 100%;
    position: relative;
    background-color: #f5f5f5;
}

.dispositivos-content {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    background-color: #f5f5f5;
    width: 100%;
}

// Estilos específicos para componentes de dispositivos médicos
:deep(.dashboard-card) {
    background: white;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    border-left: 4px solid #607D8B;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        border-left-color: #455A64;
    }

    .card-content {
        text-align: center;

        .card-icon {
            font-size: 2.5em;
            color: #607D8B;
            margin-bottom: 15px;
        }

        h3 {
            color: #455A64;
            margin: 10px 0;
            font-size: 1.2em;
        }

        p {
            color: #666;
            margin: 0;
            font-size: 0.9em;
        }
    }
}

:deep(.stat-card) {
    background: white;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-left: 4px solid #607D8B;

    h4 {
        color: #455A64;
        margin: 0 0 10px 0;
        font-size: 0.9em;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .stat-number {
        color: #607D8B;
        font-size: 2em;
        font-weight: bold;
        margin: 0;
    }
}

// Estilos para tablas
:deep(.el-table) {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .el-table__header {
        background-color: #607D8B;
        
        th {
            background-color: #607D8B;
            color: white;
            font-weight: bold;
        }
    }
}

// Estilos para botones
:deep(.el-button--primary) {
    background-color: #607D8B;
    border-color: #607D8B;

    &:hover {
        background-color: #455A64;
        border-color: #455A64;
    }
}

// Estilos para cards
:deep(.el-card) {
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: none;

    .el-card__header {
        background-color: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
        color: #455A64;
        font-weight: bold;
    }
}

// Responsive
@media (max-width: 768px) {
    .dispositivos-content {
        padding: 10px;
    }
}
</style>